import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { LMSDataService } from "@/services/lms_data";
import { ApprenticeshipAppointmentType } from "@/types/apprenticeship/enterprise";
import { UserRoundCheck } from "lucide-react";
import { DateTime } from "luxon";
import { useState } from "react";
import { toast } from "sonner";

export default function AppointmentConfirmDialog({ appointment, size = 20, children }: { appointment: ApprenticeshipAppointmentType; size?: number; children?: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger
                asChild
                onClick={() => {
                    setIsOpen(true);
                }}
            >
                {children || <UserRoundCheck width={size} height={size} cursor="pointer" />}
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Confirmer la présence du rendez-vous</DialogTitle>
                    <DialogDescription>
                        En validant, vous confirmez que l'étudiant sera présent au rendez-vous du {DateTime.fromISO(appointment.dt_start).toLocaleString(DateTime.DATETIME_MED)}.
                    </DialogDescription>
                </DialogHeader>

                <DialogFooter>
                    <Button disabled={loading} variant="outline" onClick={() => setIsOpen(false)}>
                        Annuler
                    </Button>

                    <Button
                        type="submit"
                        disabled={loading}
                        onClick={() => {
                            setLoading(true);
                            const id = appointment.external_id.split(":")[1];
                            // ID is a walter-back booking_eventslot id!
                            LMSDataService.client
                                .url(`/booking/crm/event_slots/${id}/confirm/`)
                                .post()
                                .text()
                                .then(() => {
                                    setIsOpen(false);
                                    toast.success("Le rendez-vous a bien été confirmé.");
                                })
                                .catch(() => {
                                    toast.error("Une erreur s'est produite lors de la confirmation du rendez-vous.");
                                })
                                .finally(() => {
                                    setLoading(false);
                                });
                        }}
                    >
                        {loading ? "Chargement..." : "Valider"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
